module.exports = __webpack_public_path__ + "img/LSBBFinal.52fda0a6.png";